import { IOrganization } from '@boma/client-shared';
import { Action, createReducer, on } from '@ngrx/store';
import * as OrganizationActions from './organization.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const ORGANIZATION_FEATURE_KEY = 'organization';

export interface State extends EntityState<IOrganization> {
  loaded: boolean; // has the Organization been loaded
  error?: string | null; // last known error (if any)
  organization: IOrganization; // the loaded organization
}

export interface OrganizationPartialState {
  readonly [ORGANIZATION_FEATURE_KEY]: State;
}

export const organizationAdapter: EntityAdapter<IOrganization> = createEntityAdapter<
  IOrganization
>();

export const initialState: State = organizationAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  organization: null,
});

export const organizationReducer = createReducer(
  initialState,
  on(OrganizationActions.loadOrganization, (state) => ({
    ...state,
    loaded: false,
    error: null,
    organization: null,
  })),
  on(OrganizationActions.loadOrganizationSuccess, (state, { payload }) => ({
    ...state,
    loaded: true,
    organization: payload,
  })),
  on(OrganizationActions.loadOrganizationFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(OrganizationActions.updateOrganization, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    OrganizationActions.updateOrganizationSuccess,
    (state, { organization }) => ({
      ...state,
      loaded: true,
      organization: organization,
    })
  ),
  on(OrganizationActions.updateOrganizationFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return organizationReducer(state, action);
}
